<template>
  <div class="scroll-container">
    <v-img v-if="!$vuetify.breakpoint.mdAndUp" style="width: 120px" src="logo_new.png" alt="moverai"></v-img>
    <h2 class="ma-2 text-center font-weight-medium">
      Inventory Analyzer
    </h2>
    <Confirm ref="confirm"></Confirm>
    <v-snackbar v-if="successMessage" v-model="successMessage" :timeout="5000" color="success">
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-container class="ma-2" v-if="currentService">
      <h3>Customer Name:</h3>
      {{ shipment.customer_name }}
      <h3>Moving From:</h3>
      {{ currentService.shipment_stop[0] ? currentService.shipment_stop[0].full_address : "TBD" }}
      <h3>Moving To:</h3>
      {{ currentService.shipment_stop[1] ? currentService.shipment_stop[1].full_address : "TBD" }}
    </v-container>
    <v-container v-if="!inventoryTableReady" fluid class="pa-2 ">
      <!-- Tappable field -->
      <v-text-field
        v-model="selectedRoom.room"
        label="Select Room"
        readonly
        outlined
        rounded
        prepend-inner-icon="mdi-home"
        class="mobile-combo"
        @click="dialog = true"
      ></v-text-field>

      <!-- Full-screen popup -->
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <!-- Top toolbar -->
          <v-toolbar color="primary" dark>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Select Room</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <!-- Scrollable list -->
          <v-card-text class="pa-0">
            <v-list>
              <v-list-item v-for="(room, index) in sortedRooms" :key="index" @click="selectRoom(room)">
                <v-list-item-content>
                  <v-list-item-title>{{ room.room }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <VInventoryVideoUploader
      :shipmentInventory="shipment.inventory"
      :service_date="currentService.service_date"
      :from="currentService.shipment_stop[0] ? currentService.shipment_stop[0].full_address : 'TBD'"
      :room="selectedRoom.room"
      :shipmentId="shipmentId"
      :to="currentService.shipment_stop[1] ? currentService.shipment_stop[1].full_address : 'TBD'"
      v-if="shipment && !inventoryTableReady"
    ></VInventoryVideoUploader>

    <v-form v-if="shipment && inventoryTableReady" ref="form">
      <v-form-component
        ref="formComponent"
        :parentModel="shipment"
        :key="formKey"
        :model="inventoryModel"
        :vModel="inventoryModel"
        :schema="inventorySchema"
        :data_object="inventoryDataObject"
      ></v-form-component>
      <v-toolbar flat color="white" class="elevation-6 toolbar-bottom">
        <v-spacer></v-spacer>

        <v-btn class="ma-2" @click="submit" color="success" dark>
          <v-icon left>mdi-check</v-icon>
          Submit
        </v-btn>

        <v-btn
          class="ma-2"
          @click="
            inventoryTableReady = false;
            dialog = true;
          "
          color="info"
          dark
        >
          <v-icon left>mdi-home-plus</v-icon>
          Select Another Room
        </v-btn>
      </v-toolbar>
    </v-form>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
// import Confirm from "@/components/Confirm";
export default {
  name: "CustomerInventory",
  components: {
    VInventoryVideoUploader: () => import("../components/InventoryVideoUploader.vue"),
    VCombo: () => import("../components/ComboBox.vue"),
    VFormComponent: () => import("../components/FormComponent.vue"),
    Confirm: () => import("../components/Confirm")
  },
  props: {},
  data() {
    return {
      portalId: 0,
      customerId: "",
      successMessage: "",
      errorMessage: "",
      customer: null,
      shipmentId: "",
      shipment: null,
      currentService: null,
      selectedRoom: { room: "Living Room" },
      rooms: [],
      dialog: false,
      inventoryModel: null,
      inventorySchema: null,
      inventoryDataObject: null,
      inventoryTableReady: false
    };
  },
  mounted() {
    var that = this;
    this.decryptId();
    this.$root.$on("inventoryReady", f => {
      that.inventoryTableReady = true;
    });
  },
  beforeDestroy() {},
  computed: {
    sortedRooms() {
      return [...this.rooms].sort((a, b) => a.room.localeCompare(b.room, undefined, { sensitivity: "base" }));
    }
  },
  methods: {
    selectRoom(room) {
      this.selectedRoom = room;
      this.dialog = false;
    },
    decryptId() {
      var that = this;
      var msg = this.$router.currentRoute.params.id;
      this.decr = fun.decrypt(msg, this.passPhrase);
      this.portalId = this.decr.split(":")[0];
      this.portal = "emover_" + this.portalId;
      this.shipmentId = this.decr.split(":")[1];

      var data = {
        object_name: "shipment",
        db_name: this.portal,
        qry: {
          shipment_id: parseInt(this.shipmentId)
        },
        additional_data: [
          {
            obj_name: "room"
          }
        ]
      };

      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.shipment = response.data.model[0];
          this.rooms = response.data.additional_model.room;
          this.currentService = this.shipment.estimate["non-binding"].shipment_service[0];
          this.inventoryModel = { inventory: this.shipment.inventory };
          this.inventorySchema = { inventory: response.data.schema.properties.inventory };
          that.inventorySchema.inventory["v-bind"].toolBarControls = [];
          that.inventorySchema.inventory["v-bind"].mobileBreakpoint = "0";
          that.inventorySchema.inventory["v-bind"].editRow = false;
          that.inventorySchema.inventory["v-bind"].disablePagination = true;
          //mobile-breakpoint
          that.inventorySchema.inventory.table_properties.headers.forEach((k, i) => {
            if (!["item", "qty", "room"].includes(k.value)) {
              that.inventorySchema.inventory.table_properties.headers[i].show = false;
              that.inventorySchema.inventory.table_properties.headers[i].hidden = true;
            }
          });
          var tableProperties = that.inventorySchema.inventory.table_properties.schema.properties;
          Object.keys(tableProperties).forEach(k => {
            if (!["item", "qty", "room"].includes(k)) {
              tableProperties[k].hideInTable = true;
            }
          });
          that.inventoryDataObject = {
            schema: that.inventorySchema.inventory
          };

          that.$root.$confirm = that.$refs.confirm;
        });
    },
    submit() {
      var data = {
        metadata: {
          object_name: "shipment",
          portal_id: this.portalId
        },
        model: this.shipment
      };
      // if (this.$root.customerId) {
      //   this.shipment.submitted_by_customer = true;
      // }

      this.axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          this.successMessage = response.data.msg;
        });
    }
  }
};
</script>

<style lang="css">
.mobile-combo {
  width: 100%;
  font-size: 16px;
}

.toolbar-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  border-top: 1px solid #ddd;
}

.scroll-container {
  height: 100%;
  width: 100%;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>
